﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const GUIController_1 = require("./appControllers/GUIController");
const StateDashboard_1 = require("./states/StateDashboard");
const gs_1 = require("@ivanlog/gs");
const StateUp_1 = require("./states/abstracts/StateUp");
const StateLoading_1 = require("./states/StateLoading");
const DesignThemeEnum_1 = require("./enums/DesignThemeEnum");
const Web3Controller_1 = require("./appControllers/Web3Controller");
class App {
    constructor() {
        App.Inst = this;
        StateUp_1.StateUp.App = this;
        gs_1.StateGS.DefaultStateName = 'loading';
        this.gui = new GUIController_1.GUIController(this);
        this.chain = new Web3Controller_1.Web3Controller(this);
        this.gui.setTheme(DesignThemeEnum_1.DesignThemeEnum.LightGrey);
        this.start();
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            gs_1.StateGS.RegState(StateLoading_1.StateLoading);
            gs_1.StateGS.RegState(StateDashboard_1.StateDashboard);
            gs_1.StateGS.DefaultStateName = StateDashboard_1.StateDashboard.StateName;
            yield gs_1.StateGS.Run(StateLoading_1.StateLoading);
            yield this.chain.start();
            if (this.chain.isConnected) {
                yield gs_1.StateGS.Run(StateDashboard_1.StateDashboard);
                // const byUrl = await StateGS.RunByUrl()
                // if (byUrl === StateRunResultEnum.Failed) 
            }
            else {
                yield gs_1.StateGS.Run(StateLoading_1.StateLoading);
            }
        });
    }
}
exports.App = App;
App.ADDRESS_upManager = "0x2d438666853205901f63940775a38F3c88ed3Aa5";
App.ADDRESS_upValidatorsFee = "0x496Cf17010A986F43093fC0a6DAFaccF0059234c";
App.version = "1.0.3";
//# sourceMappingURL=App.js.map